import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ChangeClientStatusFormErrorStatesEnum {
    UpdateClientStatusFailed = ErrorStateScheduleEnum.ChangeIndividualStatusFormStatesStartIndex,
    CantFindTradingClient,
    UpdateTradingAccountStatusFailed,
    UpdateTradingGroupStatusFailed,
    CantFindGroupsAndAccountsForActivation,
    ChangeStatusToTerminatedRestricted
}
